import { Component, OnInit, Input } from '@angular/core';
import {Menu} from '../../../../../../shared/services/menu/menu';
import {TranslateService} from '@ngx-translate/core';
import {GenericCrudService} from '../../../../../../shared/services/generic-crud.service';
import {MessageGrowlService} from '../../../../../message/message-growl.service';
import {RequestCachingService} from '../../../../../../shared/services/request-caching.service';
import {environment} from '../../../../../../../environments';
import {File} from '../../../../../../shared/models/file';
import {forkJoin, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {ChangeDetectorRefHelper} from '../../../../../../shared/helpers/change-detector-ref.helper';

@Component({
    selector: 'app-bonus-time-import-menu-item',
    templateUrl: './bonus-time-import-menu-item.component.html',
    styleUrls: ['./bonus-time-import-menu-item.component.scss']
})
export class BonusTimeImportMenuItemComponent implements OnInit {

  @Input() iconsPath = '';
  @Input() item: Menu;
  @Input() menuPosition = 'left';

  public isDialogVisible = false;
  selectedDate = null;

  public baseUrl = '';
  public isDataLoading = false;

  constructor(
    protected translateService: TranslateService,
    protected genericCrudService: GenericCrudService,
    protected messageGrowlService: MessageGrowlService,
    protected requestCachingService: RequestCachingService
  ) {
    this.baseUrl = environment.baseUrl;
  }

  ngOnInit() {

  }

  public onItemClick(item) {
    this.isDialogVisible = true;
    return false;
  }

  public onUpload({files}: { files: File[] }): void {
    this.upload(files).subscribe(() => {

    });
  }

  public upload(files): Observable<any> {
    const observables = [];

    this.isDataLoading = true;
    if (files.length === 0) {
      console.error('No files set for upload!');
      return of(null);
    }

    let i = 0;
    for (const file of files) {
      const fileEntity = {
        name: file.name,
        file: file,
        fileType: file.type,
        fileSize: file.size,
        date: new Date(this.selectedDate).toLocaleDateString()
      }
      observables.push(this.genericCrudService.upload(`phoenix/bonustimeentries/import?`, fileEntity));
      i++;
    }

    return forkJoin(observables)
      .pipe(
        map(() => {
          this.dialogHide();
          ChangeDetectorRefHelper.detectChanges(this);
        }));
  }

  dialogHide() {
    this.isDialogVisible = false;
    this.isDataLoading = false;
  }
}
